import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, Typography, TextField } from '@mui/material';

const defaultShortRows = [
  '22K GOLD',
  '22K GOLD',
  'Jink',
  'Chain',
  'Ball',
  'Work',
  'Reject',
];

const TransactionShortTable = ({ rightCells = [], shortRows = defaultShortRows, onChange }) => (
  <TableContainer component={Paper} sx={{ mb: 2 }}>
    <Table size="small">
      <TableBody>
        {shortRows.map((label, idx) => (
          <TableRow key={label + idx}>
            <TableCell sx={{ fontWeight: 600, width: 120 }}>{label}</TableCell>
            <TableCell>
              <TextField
                value={rightCells[idx] || ''}
                onChange={e => onChange && onChange(idx, e.target.value)}
                size="small"
                variant="standard"
                fullWidth
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

export default TransactionShortTable; 